import React, { useEffect, useState } from "react";
import eventEmitter from "../../../shared/events";

import Modal from "../../../components/modal";
import NoteLoader from "../../../components/notes/components/note-loader";
import PaginatedTable from "../../../components/table";

import { buildProfilingColumns } from "../lib/constants";
import { filterTask } from "../../../components/task-list/lib/taskData";
import { SECTION_MAP } from "../../../components/task-list/lib/constants";
import { useSettings } from "../../../shared/hooks/use-settings";

export const Profiling = ({ usersWithAssignments, disableNotes, ...props }) => {
    const [noteSettings, setNoteSettings] = useState(null);
    const { settings } = useSettings();

    useEffect(() => {
        eventEmitter.on("UPDATE_NOTE_SETTINGS", updateNoteSettings);

        return () => {
            eventEmitter.removeListener("UPDATE_NOTE_SETTINGS", updateNoteSettings);
        };
    }, []);

    const updateNoteSettings = (newSettings) => {
        setNoteSettings({ ...newSettings, taskType: SECTION_MAP[props.taskType].noteKey, isReadOnly: disableNotes });
    };

    const updateSelectedUpc = (obj, isRemove) => {
        if (isRemove === "true") {
            props.setSelectedProducts(props.selected.filter((i) => i.key !== obj.key));
        } else {
            props.setSelectedProducts([...props.selected, obj]);
        }
    };

    const setAllUpcs = (selections) => {
        props.setSelectedProducts([...selections]);
    };

    const updateTeamFilter = (team) => {
        props.setTeamFilter(team);
    };

    const closeNotesModal = () => {
        setNoteSettings(null);
    };

    const selectedIds = props.selected.map((s) => s.key);

    const upcTotal = props.selected.reduce((total, selected) => {
        return total + selected.upcs.length;
    }, 0);

    return (
        <div>
            <p className="m-b-20 txt-bold">
                {props.selected.length} Shipments, {upcTotal} UPCs Selected
            </p>
            <PaginatedTable
                appendSettings={props.appendSettings}
                getData={filterTask}
                columns={buildProfilingColumns(
                    updateSelectedUpc,
                    setAllUpcs,
                    selectedIds,
                    props.locations,
                    props.assignments,
                    props.statuses,
                    usersWithAssignments,
                    updateTeamFilter,
                    props.taskType,
                    settings.locationDataSources
                )}
                showPagination
                updatePulse={props.updatePulse}
            />
            <Modal
                show={!!noteSettings}
                onClose={closeNotesModal}
            >
                <NoteLoader settings={noteSettings} />
            </Modal>
        </div>
    );
};
